<template>
    <div class="m-2">
        <div class="p-4 bg-white rounded-lg bg-shadow">
            <div class="pb-0 pt-2">
                <div class="profileinfo">ข้อมูลของท่าน</div>
            </div>
            <div class="py-4 text-12 font-light text-a-black-484848">
                <div class="flex justify-between">
                    <div>ชื่อ - นามสกุล</div>
                    <div>{{profile.firstName?profile.firstName:"-"}} {{profile.lastName?profile.lastName:"-"}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>เลขประจำตัวประชาชน</div>
                    <div>{{profile.citizenId?profile.citizenId:"-"}}</div>
                </div>

                <div class="flex justify-between pt-2">
                    <div>วัน / เดือน / ปีเกิด</div>
                    <div>{{profile.birthDate?profile.birthDate.split(' ')[0]:"-"}} </div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>เบอร์โทรศัพท์มือถือ</div>
                    <div>{{profile.mobileNo?profile.mobileNo:"-"}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>อีเมล</div>
                    <div>{{profile.emails?profile.emails:"-"}}</div>
                </div>
            </div>

            <div class="py-4 text-12 border-t font-light text-a-black-484848">
                <div class="pt-0">ที่อยู่</div>
                <div class="pt-2 leading-normal">
                    {{profile.address?profile.address:"-"}}
                    {{profile.districtName?profile.districtName:""}}
                    {{profile.provinceName?profile.provinceName:""}}
                    {{profile.zipcode?profile.zipcode:""}}
                </div>
            </div>


            <div class="info_bottom">
                <div class="leading-normal">หากข้อมูลของท่านไม่ถูกต้อง<br/>
                ติดต่อศูนย์บริการลูกค้า ธนชาตประกันภัย <br/>
                วันและเวลาทำการ จันทร์ - ศุกร์ เวลา 08.30 - 17.00 น.
                </div>
                <div class=" text-a-orange-fe5000 underline font-medium">
                    <a class="tel" href="tel:023089222">โทร. 02-308-9222</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Account from "@/helper/AccountHelper.js";
import ModalMixin from "@/mixin/ModalMixin";
//service
import ProfileApi from "../service/ProfileApi";

export default {
    name: 'ProfileInfo',
    data: function () {
        return {
            userCookie: {},
            profile: {}
        };
    },
    mixins: [ModalMixin],
    created: function () {
        this.userCookie = Account.getCacheUser();
    },
    mounted: function(){
        this.modal.loadingModal.show()
        this.apiProfile()
    },
    methods: {
        apiProfile: function () {
            return new Promise((resolve) => {
                let token = this.userCookie.token;
                ProfileApi.apiCustomerInfo(token).subscribe({
                    next: (profile) => {
                        this.modal.loadingModal.hide()
                        console.log(profile);
                        this.profile = profile;
                        resolve(profile);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide()
                        resolve(null);
                        this.errorApi(err);
                        
                    },
                });
            });
        },
    },
}
</script>

<style>
.bg-shadow {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
}
.profileinfo {
    @apply text-16 font-medium text-a-black-555555;
    line-height: 22px;
}
.info_bottom {
    @apply pt-86 pb-1 text-12 font-light text-a-gray-afafaf text-center;
    padding-top: 70px;
}
</style>
